import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SettingsPreferenceOption } from '../../../@store';
import { SettingsOption } from './setting';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingComponent {
  @Input() options: SettingsOption[];
  @Input() currentValue: string;

  @Output() valueChange: EventEmitter<{
    newValue: string;
    currentValue: string;
  }> = new EventEmitter<{
    newValue: string;
    currentValue: string;
  }>();
  @Output() additionalOptionSelected: EventEmitter<void> = new EventEmitter<void>();

  emit(value: SettingsPreferenceOption): void {
    this.valueChange.emit({ newValue: value, currentValue: this.currentValue });
  }

  onAdditionalOptionSelected(event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    this.additionalOptionSelected.emit();
  }
}
